import React from 'react';


const ToolbarSpacer = () => {
    return (
        <div style={{ marginLeft: "auto", marginRight: "auto" }} >&nbsp;</div>
    )
}

export default ToolbarSpacer